/* ---------- Suggestions: one-tap add ---------- */
if (!customElements.get('m-cart-upsell')) {
  class MCartUpsell extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => this.onClick(event));
    }

    async onClick(event) {
      const btn = event.target.closest('[data-upsell-add]');
      if (!btn || btn.classList.contains('is-loading')) return;
      const label = btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = 'Adding...';
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }),
        });
        if (!res.ok) throw new Error('add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
      } catch (e) {
        btn.classList.remove('is-loading');
        btn.textContent = 'Try again';
        setTimeout(() => { btn.textContent = label; }, 2000);
      }
    }
  }
  customElements.define('m-cart-upsell', MCartUpsell);
}

/* ---------- Milestone celebration: confetti + toast when a stop is reached ---------- */
(() => {
  if (window.__mpCartCelebrate) return;
  window.__mpCartCelebrate = true;

  const COLORS = ['#183a4a', '#2f7a5b', '#c9a24a', '#e9e2d8', '#e07a5f', '#f4d58d'];
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let layer = null;
  let prev = null;
  let queue = [];
  let busy = false;

  const read = () => {
    const el = document.querySelector('.mp-cartgoal');
    return { ship: !!el && el.dataset.ship === 'true', gift: !!el && el.dataset.gift === 'true' };
  };

  const getLayer = () => {
    if (layer && layer.isConnected) return layer;
    layer = document.createElement('div');
    layer.setAttribute('aria-hidden', 'true');
    layer.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:2147483000;overflow:hidden;';
    document.body.appendChild(layer);
    return layer;
  };

  const burst = (x, y) => {
    const host = getLayer();
    for (let i = 0; i < 36; i++) {
      const p = document.createElement('i');
      const size = 6 + Math.random() * 5;
      const round = Math.random() > 0.6;
      p.style.cssText = 'position:absolute;left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + (round ? size : size * 0.5) + 'px;background:' + COLORS[i % COLORS.length] + ';border-radius:' + (round ? '50%' : '1px') + ';will-change:transform,opacity;';
      host.appendChild(p);
      const angle = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.1;
      const dist = 70 + Math.random() * 110;
      const dx = Math.cos(angle) * dist;
      const dy = Math.sin(angle) * dist;
      const rot = (Math.random() - 0.5) * 720;
      const fall = 90 + Math.random() * 90;
      const anim = p.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx * 1.2 + 'px,' + (dy + fall) + 'px) rotate(' + rot + 'deg)', opacity: 0 },
      ], { duration: 1300 + Math.random() * 600, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' });
      anim.onfinish = () => p.remove();
    }
  };

  const toast = (text, cx, top) => {
    const host = getLayer();
    const t = document.createElement('div');
    t.textContent = text;
    t.style.cssText = 'position:absolute;left:' + cx + 'px;top:' + top + 'px;padding:8px 16px;background:#2f7a5b;color:#fff;font:600 13px/1.2 inherit;letter-spacing:.02em;border-radius:999px;box-shadow:0 6px 18px rgba(0,0,0,.18);white-space:nowrap;';
    host.appendChild(t);
    const anim = t.animate([
      { opacity: 0, transform: 'translate(-50%,-8px) scale(.92)' },
      { opacity: 1, transform: 'translate(-50%,0) scale(1)', offset: 0.15 },
      { opacity: 1, transform: 'translate(-50%,0) scale(1)', offset: 0.8 },
      { opacity: 0, transform: 'translate(-50%,-6px) scale(.98)' },
    ], { duration: 2200, easing: 'ease-out', fill: 'forwards' });
    anim.onfinish = () => t.remove();
  };

  const celebrate = (kind) => {
    const bar = document.querySelector('.mp-cartgoal');
    if (!bar) return false;
    const br = bar.getBoundingClientRect();
    if (br.width === 0 || br.right <= 0 || br.left >= window.innerWidth) return false; // drawer not on screen
    const stop = bar.querySelectorAll('.mp-cartgoal__stop')[kind === 'gift' ? 1 : 0];
    const sr = stop ? stop.getBoundingClientRect() : br;
    toast(kind === 'gift' ? 'Free surprise scent unlocked!' : 'Free shipping unlocked!', br.left + br.width / 2, br.top + 2);
    if (!reduceMotion) burst(sr.left + sr.width / 2, sr.top + sr.height / 2);
    return true;
  };

  const runQueue = () => {
    if (busy || !queue.length) return;
    busy = true;
    const kind = queue.shift();
    // wait for the bar fill animation to reach the stop before celebrating
    setTimeout(() => {
      celebrate(kind);
      setTimeout(() => { busy = false; runQueue(); }, 1800);
    }, 500);
  };

  const check = () => {
    const now = read();
    if (prev) {
      if (!prev.ship && now.ship) queue.push('ship');
      if (!prev.gift && now.gift) queue.push('gift');
      if (queue.length) runQueue();
    }
    prev = now;
  };

  let scheduled = false;
  const schedule = (mutations) => {
    if (layer && mutations && mutations.every((m) => layer.contains(m.target))) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; check(); });
  };

  const init = () => {
    prev = read(); // starting state: never celebrate what was already unlocked on page load
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) init();
  else document.addEventListener('DOMContentLoaded', init);
})();
